(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var config = JSON.parse(document.querySelector('[data-cart-config]').textContent);
  var itemsBox = drawer.querySelector('[data-cart-items]');
  var scroll = drawer.querySelector('.lz-cart-scroll');
  var foot = drawer.querySelector('[data-cart-foot]');
  var totalEl = drawer.querySelector('[data-cart-total]');
  var savedEl = drawer.querySelector('[data-cart-saved]');
  var countEl = drawer.querySelector('[data-cart-drawer-count]');
  var errorEl = drawer.querySelector('[data-cart-error]');
  var progress = drawer.querySelector('[data-cart-progress]');
  var progressText = drawer.querySelector('[data-cart-progress-text]');
  var progressBar = drawer.querySelector('[data-cart-progress-bar]');
  var upsell = drawer.querySelector('[data-cart-upsell]');
  var upsellTitle = drawer.querySelector('[data-cart-upsell-title]');
  var upsellItems = drawer.querySelector('[data-cart-upsell-items]');
  var comparePrices = {};
  config.products.forEach(function (product) {
    product.variants.forEach(function (v) {
      if (v.compare_at_price) comparePrices[v.id] = v.compare_at_price;
    });
  });

  function money(cents) { return (cents / 100).toLocaleString('en-US') + ' EGP'; }
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function showError(message) { errorEl.textContent = message; errorEl.hidden = !message; }
  function wasPrice(item) {
    var compare = comparePrices[item.variant_id];
    return compare ? Math.max(compare * item.quantity, item.original_line_price) : item.original_line_price;
  }
  function thumbNode(src) {
    var thumb;
    if (src) {
      thumb = el('img', 'lz-cart-thumb');
      thumb.src = src;
      thumb.alt = '';
    } else {
      thumb = el('div', 'lz-cart-thumb');
    }
    return thumb;
  }

  function run(request) {
    showError('');
    scroll.setAttribute('aria-busy', 'true');
    return request.then(function (res) {
      if (!res.ok) throw new Error('cart request failed');
      return load();
    }).catch(function () {
      showError('We could not update your cart. Please try again.');
    }).then(function () {
      scroll.removeAttribute('aria-busy');
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function change(key, quantity) { run(post('/cart/change.js', { id: key, quantity: quantity })); }

  function lineNode(item) {
    var line = el('article', 'lz-cart-line');
    line.appendChild(thumbNode(item.image));
    var info = el('div');
    info.appendChild(el('p', 'lz-cart-name', item.product_title));
    if (item.variant_title) info.appendChild(el('p', 'lz-cart-variant', item.variant_title));
    var price = el('p', 'lz-cart-price', money(item.final_line_price));
    var was = wasPrice(item);
    if (was > item.final_line_price) {
      price.appendChild(el('del', '', money(was)));
    }
    info.appendChild(price);

    var controls = el('div', 'lz-cart-controls');
    var qty = el('div', 'lz-cart-qty');
    var minus = el('button', '', '−');
    minus.type = 'button';
    minus.setAttribute('aria-label', 'Decrease quantity');
    minus.addEventListener('click', function () { change(item.key, item.quantity - 1); });
    var plus = el('button', '', '+');
    plus.type = 'button';
    plus.setAttribute('aria-label', 'Increase quantity');
    plus.addEventListener('click', function () { change(item.key, item.quantity + 1); });
    qty.appendChild(minus);
    qty.appendChild(el('span', '', item.quantity));
    qty.appendChild(plus);
    controls.appendChild(qty);
    var remove = el('button', 'lz-cart-remove', 'Remove');
    remove.type = 'button';
    remove.addEventListener('click', function () { change(item.key, 0); });
    controls.appendChild(remove);
    info.appendChild(controls);
    line.appendChild(info);
    return line;
  }

  function upsellNode(product) {
    var card = el('article', 'lz-cart-upsell-card');
    card.appendChild(thumbNode(product.image));
    var info = el('div');
    info.appendChild(el('p', 'lz-cart-name', product.title));
    info.appendChild(el('p', 'lz-cart-variant', money(product.price)));
    var row = el('div', 'lz-cart-upsell-row');
    var select = el('select');
    select.setAttribute('aria-label', 'Size for ' + product.title);
    var placeholder = el('option', '', 'Choose size');
    placeholder.value = '';
    select.appendChild(placeholder);
    product.variants.forEach(function (v) {
      var opt = el('option', '', v.option2);
      opt.value = v.id;
      opt.disabled = !v.available;
      select.appendChild(opt);
    });
    var add = el('button', '', 'Add');
    add.type = 'button';
    add.addEventListener('click', function () {
      if (!select.value) { showError('Please choose a size first.'); select.focus(); return; }
      run(post('/cart/add.js', { items: [{ id: Number(select.value), quantity: 1 }] }));
    });
    row.appendChild(select);
    row.appendChild(add);
    info.appendChild(row);
    card.appendChild(info);
    return card;
  }

  function renderUpsell(cart) {
    var familyIds = config.products.map(function (p) { return p.id; });
    var pieces = 0;
    var inCart = {};
    cart.items.forEach(function (item) {
      inCart[item.product_id] = true;
      if (familyIds.indexOf(item.product_id) !== -1) pieces += item.quantity;
    });
    var options = config.products.filter(function (p) { return !inCart[p.id]; }).slice(0, 2);
    upsellItems.textContent = '';
    if (!cart.item_count || !options.length) { upsell.hidden = true; return; }
    if (pieces === 1) upsellTitle.textContent = 'Add 1 more and pay ' + money(config.deals[1]) + ' for 2';
    else if (pieces === 2) upsellTitle.textContent = 'Add 1 more and pay ' + money(config.deals[2]) + ' for 3';
    else upsellTitle.textContent = 'Add another color';
    options.forEach(function (p) { upsellItems.appendChild(upsellNode(p)); });
    upsell.hidden = false;
  }

  function renderProgress(cart) {
    if (!cart.item_count) { progress.hidden = true; return; }
    var remaining = config.freeShipping - cart.total_price;
    var percent = Math.min(100, Math.round(cart.total_price / config.freeShipping * 100));
    progressText.textContent = remaining > 0
      ? 'Add ' + money(remaining) + ' more for free shipping.'
      : 'You got free shipping!';
    progressBar.style.width = percent + '%';
    progress.hidden = false;
  }

  function render(cart) {
    countEl.textContent = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    itemsBox.textContent = '';
    renderProgress(cart);
    renderUpsell(cart);
    if (!cart.item_count) {
      itemsBox.appendChild(el('p', 'lz-cart-empty', 'Your cart is empty.'));
      foot.hidden = true;
      return;
    }
    var wasTotal = 0;
    cart.items.forEach(function (item) {
      itemsBox.appendChild(lineNode(item));
      wasTotal += wasPrice(item);
    });
    var saved = wasTotal - cart.total_price;
    totalEl.textContent = '';
    if (saved > 0) totalEl.appendChild(el('del', '', money(wasTotal)));
    totalEl.appendChild(document.createTextNode(money(cart.total_price)));
    savedEl.textContent = 'You saved ' + money(saved);
    savedEl.hidden = saved <= 0;
    foot.hidden = false;
  }

  function load() {
    return fetch('/cart.js').then(function (res) { return res.json(); }).then(render);
  }

  function open() {
    showError('');
    return load().then(function () {
      if (!drawer.open) drawer.showModal();
    });
  }

  drawer.querySelector('[data-cart-close]').addEventListener('click', function () { drawer.close(); });
  drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });
  document.addEventListener('looz:cart-added', open);
  document.querySelectorAll('.lz-cart-link').forEach(function (link) {
    link.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
})();
